export interface FnCsvOption {
	filename?: string;
	fieldSeparator?: string;
	quoteStrings?: string;
	decimalseparator?: string;
	showLabels?: boolean;
	showTitle?: boolean;
	title?: string;
	useBom?: boolean;
	headers?: string[];
	sortByKeys?: string[];
	noDownload?: boolean;
	removeEmptyValues?: boolean;
	text?: string;
}

export const isJsons = (array: any[]) =>
	Array.isArray(array) &&
	array.every((row) => typeof row === 'object' && !(row instanceof Array));

export interface FnCsvHeader {
	label: string;
	key: string;
}

export class FnCsvConfigConsts {
	public static readonly EOL = '\r\n';
	public static readonly BOM = '\ufeff';
	public static readonly DEFAULT_FIELD_SEPARATOR = ',';
	public static DEFAULT_DECIMAL_SEPARATOR = '.';
	public static DEFAULT_QUOTE = '"';
	public static DEFAULT_SHOW_TITLE = false;
	public static DEFAULT_TITLE = 'My Report';
	public static DEFAULT_FILENAME = 'download';
	public static DEFAULT_SHOW_LABELS = false;
	public static DEFAULT_USE_BOM = true;
	public static DEFAULT_HEADER: any[] = [];
	public static DEFAULT_NO_DOWNLOAD = false;
	public static DEFAULT_REMOVE_EMPTY_VALUES = false;
	public static DEFAULT_TEXT = 'Download';
	public static DEFAULT_SORTKEYS: any[] = [];
}

export const FnCsvConfigDefaults: FnCsvOption = {
	filename: FnCsvConfigConsts.DEFAULT_FILENAME,
	fieldSeparator: FnCsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
	quoteStrings: FnCsvConfigConsts.DEFAULT_QUOTE,
	decimalseparator: FnCsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
	showLabels: FnCsvConfigConsts.DEFAULT_SHOW_LABELS,
	showTitle: FnCsvConfigConsts.DEFAULT_SHOW_TITLE,
	title: FnCsvConfigConsts.DEFAULT_TITLE,
	useBom: FnCsvConfigConsts.DEFAULT_USE_BOM,
	headers: FnCsvConfigConsts.DEFAULT_HEADER,
	noDownload: FnCsvConfigConsts.DEFAULT_NO_DOWNLOAD,
	removeEmptyValues: FnCsvConfigConsts.DEFAULT_REMOVE_EMPTY_VALUES,
	text: FnCsvConfigConsts.DEFAULT_TEXT,
	sortByKeys: FnCsvConfigConsts.DEFAULT_SORTKEYS,
};
